import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Pencil = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path
        d="M9 4L2.5 10.5V13.5H5.5L12 7M9 4L11.5 1.5L14.5 4.5L12 7M9 4L12 7"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Pencil.displayName = 'Pencil'

export default Pencil
